import React from 'react'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined'
import { buildAppChipSx } from '../../../components/chips/AppChip'
import {
  auditChipSx as auditChipTokens,
  auditStrikethroughChipSx
} from './rbacAuditHistoryConstants'

const ACTION_PRESETS = [
  {
    action: 'READ',
    legacyAction: 'view',
    label: 'Solo ver',
    Icon: VisibilityOutlinedIcon
  },
  {
    action: 'DOWNLOADS',
    legacyAction: 'download',
    label: 'Descargar',
    Icon: CloudDownloadOutlinedIcon
  },
  {
    action: 'READ_WRITE',
    legacyAction: 'edit',
    label: 'Todo editar',
    Icon: EditOutlinedIcon
  }
]

const auditChipSx = buildAppChipSx(auditChipTokens)

function resolvePresets(actions = []) {
  const normalized = actions.map(String)
  return ACTION_PRESETS.filter(
    (preset) => normalized.includes(preset.action) || normalized.includes(preset.legacyAction)
  )
}

function AuditPermissionChip({ label, Icon, strikethrough = false }) {
  return (
    <Box
      component="span"
      sx={{
        ...auditChipSx,
        gap: '5px',
        ...(strikethrough ? auditStrikethroughChipSx : {})
      }}
    >
      <Icon sx={{ fontSize: 13, width: 13, height: 13 }} />
      {label}
    </Box>
  )
}

export default function RbacAuditPermissionChips({ actions = [], strikethrough = false }) {
  const presets = resolvePresets(actions)
  if (presets.length === 0) return null

  return (
    <Stack direction="row" spacing={0.75} useFlexGap flexWrap="wrap" alignItems="center">
      {presets.map((preset) => (
        <AuditPermissionChip
          key={preset.action}
          label={preset.label}
          Icon={preset.Icon}
          strikethrough={strikethrough}
        />
      ))}
    </Stack>
  )
}
